/* unplugin-vue-components disabled */import { render } from "./SidenavItem.vue?vue&type=template&id=1800f037"
import script from "./SidenavItem.vue?vue&type=script&lang=js"
export * from "./SidenavItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../unionglobal-store-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__